export default {
  status: {
    pending: 'Se așteaptă DNS-ul',
    verified: 'Activ',
    failed: 'Acțiune necesară',
  },
  summary: {
    preparing:
      'Înregistrările pentru {{host}} sunt în curs de pregătire. Apar aici în aproximativ 15 minute — sau imediat după ce apăsați Verificați din nou.',
    pending:
      'Se așteaptă înregistrările DNS de mai jos. De obicei durează câteva minute și poate dura până la 48 de ore — continuăm să verificăm automat.',
    certificate_pending:
      'Înregistrările sunt la locul lor. Certificatul pentru {{host}} este în curs de emitere — de obicei durează câteva minute.',
    verified: 'Magazinul online este activ pe {{host}}.',
    serving: 'Magazinul online este activ pe {{serving_host}}, dar {{host}} încă nu îl deschide.',
    apex_elsewhere:
      'Înregistrarea A de pe @ nu indică încă spre magazin. Dacă {{host}} afișează un site web care trebuie să rămână acolo, lăsați @ așa cum este — magazinul funcționează pe {{serving_host}}. Altfel, adăugați înregistrarea A de mai jos.',
    apex_held:
      '{{host}} este folosit de un alt site web pe Vercel. Pentru ca și {{host}} să deschidă magazinul, eliminați mai întâi domeniul de pe acel site web.',
    regressed:
      '{{host}} funcționa, dar o înregistrare de mai jos nu mai este confirmată. Corectați-o la furnizorul DNS, apoi apăsați Verificați din nou.',
    record_elsewhere:
      'O înregistrare de mai jos indică în altă parte. Modificați-o la furnizorul DNS la valoarea afișată, apoi apăsați Verificați din nou.',
    records_missing:
      'Înregistrările de mai jos tot nu sunt găsite după 48 de ore. Verificați că au fost salvate pentru {{zone}}, la furnizorul care îi administrează DNS-ul. Dacă acel furnizor nu permite modificarea, domeniul poate fi blocat acolo.',
    certificate: {
      ownership_proof_required:
        '{{host}} este conectat și la un alt cont Vercel, așa că restaurantul trebuie să dovedească faptul că domeniul îi aparține.',
      held_by_another_project:
        '{{host}} este încă folosit de un alt site web pe Vercel, așa că magazinul nu îl poate folosi încă.',
      dns_correct_but_unconfigured: 'Înregistrările sunt corecte, dar altceva de pe {{host}} blochează certificatul.',
      name_mismatch: '{{host}} încă răspunde cu un certificat pentru alt nume.',
      expired: 'Certificatul pentru {{host}} a expirat. Am fost alertați și ne ocupăm de asta.',
      expiring: 'Certificatul pentru {{host}} expiră în curând și nu a fost încă reînnoit. Ne ocupăm de asta.',
      attach_refused:
        'Furnizorul nostru de găzduire a refuzat să adauge {{host}} din partea noastră. Am fost anunțați și ne ocupăm de asta.',
      overdue: 'Certificatul pentru {{host}} tot nu a fost emis după 48 de ore.',
      unknown: 'Certificatul pentru {{host}} nu a putut fi emis.',
    },
    certificate_see_row: 'Rândul certificatului de mai jos arată ce trebuie făcut.',
  },
  instructions: {
    title: 'Cum conectați {{host}}',
    step_provider:
      'Autentificați-vă acolo unde este administrat DNS-ul pentru {{zone}} — de obicei compania de la care a fost cumpărat domeniul.',
    step_add: 'Adăugați fiecare înregistrare de mai jos exact așa cum este afișată: tipul, numele și valoarea.',
    step_check: 'Salvați, apoi apăsați {{button}}. Continuăm și noi să verificăm automat.',
    tip_name:
      'Majoritatea furnizorilor vor doar partea dinaintea lui {{zone}} în câmpul pentru nume — aici {{names}}. Este afișat și numele complet, pentru furnizorii care îl cer.',
    tip_apex: '@ înseamnă chiar {{zone}}. Unii furnizori lasă în schimb numele gol.',
    tip_apex_website:
      'Dacă {{zone}} deschide deja un site web, direcționarea @ către magazin ia {{zone}} de la acel site. Pentru a păstra site-ul acolo, lăsați înregistrările de pe @ așa cum sunt — magazinul funcționează în continuare pe www.{{zone}} — sau conectați în schimb un subdomeniu precum order.{{zone}} pentru magazin.',
    tip_existing:
      'Ștergeți orice altă înregistrare A, AAAA sau CNAME de pe {{name}}. Două înregistrări care indică spre locuri diferite fac magazinul să se încarce doar uneori.',
    tip_cloudflare:
      'Pe Cloudflare, setați aceste înregistrări pe Doar DNS (nor gri). Cu proxy-ul activ, nimeni nu poate vedea unde indică și nu se poate emite niciun certificat.',
    tip_locked:
      'Dacă furnizorul nu permite adăugarea sau modificarea acestor înregistrări, domeniul poate fi blocat sau DNS-ul lui este administrat în altă parte. Furnizorul îl poate debloca sau poate spune unde este administrat DNS-ul.',
  },
  records: {
    title: 'Înregistrări pentru {{host}}',
  },
  separate_domains: {
    apex: 'Acest domeniu este doar pentru magazinul online: magazinul ocupă {{zone}} și www.{{zone}}. Un site web are nevoie de alt nume — un subdomeniu al lui {{zone}} sau un domeniu propriu.',
    subdomain: 'Acest domeniu este doar pentru magazinul online. Un site web poate folosi {{zone}} sau www.{{zone}}.',
  },
  load_error: 'Starea domeniului nu a putut fi încărcată.',
  no_access: 'Nu există acces la starea domeniului acestui restaurant.',
  polling_stopped: 'Această pagină nu se mai actualizează singură. Apăsați Verificați din nou pentru a o actualiza.',
  buttons: {
    check_again: 'Verificați din nou',
    retry: 'Încercați din nou',
  },
  toasts: {
    check_started: 'Se verifică înregistrările. Poate dura un minut.',
    check_failed: 'Verificarea nu a putut fi pornită. Încercați din nou.',
    check_too_soon: 'Tocmai s-a verificat. Așteptați un minut înainte de a verifica din nou.',
  },
};
